import axios from "@/axios.js";
import constants from "@/constants.js";

export default {
  /*async createUser({ commit }, payload) {
       try {
           const resObj = await axios.post(`${constants.apiHost}/alex`, payload);
           const data = {
               youlabId: resObj.data.youlabId,
               youlabToken: resObj.data.youlabToken,
               userProgress: resObj.data.userProgress
           };
           commit('SET_ALEX_DATA', data);
       }
       catch (err) {
           throw err;
       }
   },*/
  async fetchDetails({ commit }, userId) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/alex/`, {
        params: { userId: userId },
      });
      const data = {
        uuId: resObj.data.uuId,
        youlabToken: resObj.data.youlabToken,
        userProgress: resObj.data.progress,
        youlabId: resObj.data.youlabId,
      };
      commit("SET_ALEX_DATA", data);
      return resObj;
      // console.log({ alexData: resObj.data });

      // console.log({ alexData: resObj.data });
    } catch (err) {
      throw err;
    }
  },
  async getTrainingItems({ commit }, payload) {
    let filterQuery = "";
    if (payload.filters) {
      payload.filters.forEach((item) => {
        filterQuery += `${item.field}[$in][]=${item.value}&`;
      });
    }
    try {
      const resObj = await axios.get(
        `${constants.apiHost}/training-library?&${filterQuery}$skip=${payload.items}`
      );
      commit("SET_TRAINING_LIBRARY_DATA", resObj.data.data);
      return resObj.data;
    } catch (err) {
      throw err;
    }
  },
  async getTestItems({ commit }, payload) {
    try {
      const resObj = await axios.get(
        `${constants.apiHost}/training-library?testAvailable=true&$skip=${payload.items}`
      );
      commit("SET_TEST_LIBRARY_DATA", resObj.data.data);
      return resObj.data;
    } catch (err) {
      throw err;
    }
  },
  async fetchUserSegments({ commit }, payload) {
    try {
      const resObj = await axios.get(
        `${constants.apiHost}/user-segments?orgId=${payload.orgId}`
      );
      console.log("resObj", resObj.data);
      commit("SET_USER_SEGMENTS", resObj.data);
      return resObj.data;
    } catch (err) {
      throw err;
    }
  },
  async fetchAlexUser({ commit }, _id) {
    try {
      const resObj = await axios.get(
        `${constants.apiHost}/alex?organizationId=${_id}`
      );
      commit("SET_ALEX_USER_DATA", resObj.data);
      return resObj.data;
    } catch (err) {
      throw err;
    }
  },
  async fetcDepartmenByAlexUser({ commit }, payload) {
    try {
      const resObj = await axios.get(
        `${constants.apiHost}/alex?organizationId=${payload.organizationId}&department=${payload.department}`
      );
      //commit('SET_ALEX_USER_DATA', resObj.data);
      return resObj.data;
    } catch (err) {
      throw err;
    }
  },
  async fetchLevelByAlexUser({ commit }, payload) {
    try {
      let filterQuery = "";
      if (payload.roleTitle) {
        // // console.log(' payload.roleTitle', payload.level.length);
        for (let i = 0; i < payload.level.length; i++) {
          filterQuery += `lavel['label'][$in][]=${payload.level[i]}&`;
        }
      }
      const resObj = await axios.get(
        `${constants.apiHost}/alex?organizationId=${payload.organizationId}&${filterQuery}`
      );
      //commit('SET_ALEX_USER_DATA', resObj.data);
      return resObj.data;
    } catch (err) {
      throw err;
    }
  },
  async fetchroleTitleByAlexUser({ commit }, payload) {
    try {
      let filterQuery = "";
      if (payload.roleTitle) {
        // // console.log(' payload.roleTitle', payload.roleTitle.length);
        for (let i = 0; i < payload.roleTitle.length; i++) {
          filterQuery += `roleTitle[$in][]=${payload.roleTitle[i]}&`;
        }
      }
      const resObj = await axios.get(
        `${constants.apiHost}/alex?organizationId=${payload.organizationId}&${filterQuery}`
      );
      //commit('SET_ALEX_USER_DATA', resObj.data);
      return resObj.data;
    } catch (err) {
      throw err;
    }
  },
  async fetchIdentifiedGapsByAlexUser({ commit }, payload) {
    try {
      let filterQuery = "";
      if (payload.identifiedGaps) {
        // // console.log(' payload.identifiedGaps', payload.identifiedGaps.length);
        for (let i = 0; i < payload.roleTitle.length; i++) {
          filterQuery += `identifiedGaps[$in][]=${payload.identifiedGaps[i]}&`;
        }
      }
      const resObj = await axios.get(
        `${constants.apiHost}/alex?organizationId=${payload.organizationId}&${filterQuery}`
      );
      //commit('SET_ALEX_USER_DATA', resObj.data);
      return resObj.data;
    } catch (err) {
      throw err;
    }
  },
  async deleteSession({ commit }, userId) {
    try {
      await axios.delete(`${constants.apiHost}/alex/${userId}`);
    } catch (err) {
      throw err;
    }
  },
  async updateAlex({ commit }, data) {
    try {
      const _id = data._id;
      const resObj = await axios.patch(
        `${constants.apiHost}/alex/${_id}`,
        data
      );
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async getAssignments({ commit }, payload) {
    try {
      const resObj = await axios.get(
        `${constants.gatewayServiceUrl}/alex/library/assignments/${payload.orgId}/${payload.userId}`
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  // library assignments
  async getOrgAssignments({ commit }, orgId) {
    try {
      const resObj = await axios.get(
        `${constants.gatewayServiceUrl}/alex/library/assignment/grouped/${orgId}`
      );
      commit(
        "SET_ORG_ASSIGNMENTS",
        resObj && resObj.data && resObj.data.data ? resObj.data.data : []
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async assignValidation({ commit }, payload) {
    try {
      const resObj = await axios.post(
        `${constants.gatewayServiceUrl}/alex/library/library-item/validation`,
        payload
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async reviewAssignment({ commit }, payload) {
    try {
      const resObj = await axios.post(
        `${constants.gatewayServiceUrl}/alex/library/assignment/review
        `,
        payload
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  // get clicked items on library redirect page
  async getRedirectItemsCount(_, payload) {
    try {
      const resObj = await axios.post(
        `${constants.gatewayServiceUrl}/alex/library/assignment/merged-analytics-validation`,
        payload
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async getUserItems(_, payload) {
    try {
      const resObj = await axios.get(
        `${constants.gatewayServiceUrl}/alex/library/assignment/user/${payload.orgId}/${payload.userId}`
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async claimRewards({ commit }, payload) {
    try {
      const resObj = await axios.post(
        `${constants.gatewayServiceUrl}/alex/library/assignment/claim-token`,
        payload
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchQuiz(_, payload) {
    try {
      const resObj = await axios.get(
        `${constants.feedServiceUrl}/getitemquiz?itemId=${payload.itemId}&getboardedOrgId=${payload.orgId}`
      );

      return resObj.data;
    } catch (error) {
      return error;
    }
  },
  async fetchCustomLibraryItem(_, payload) {
    try {
      const resObj = await axios.get(
        `${constants.gatewayServiceUrl}/alex/library/library-item-group/sub-item/${payload.orgId}/${payload.userId}/${payload.itemId}`
      );
      return resObj.data;
    } catch (error) {
      return error;
    }
  },
  async fetchLibraryItemDetails(_, payload) {
    try {
      const resObj = await axios.get(
        `${constants.feedServiceUrl}/getitemdetails?itemId=${payload.itemId}&type=${payload.type}&getboardedId=${payload.userId}`
      );
      return resObj.data;
    } catch (error) {
      return error;
    }
  },
  async fetchItemValidationDetails(_, payload) {
    try {
      const resObj = await axios.get(
        `${constants.gatewayServiceUrl}/alex/library/library-item/validation/${payload.orgId}/${payload.itemId}`
      );
      return resObj.data;
    } catch (error) {
      return error;
    }
  },
  async fetchDoneUsersItems(_, payload) {
    try {
      const resObj = await axios.get(
        `${constants.gatewayServiceUrl}/alex/library/assignment/user-done/${payload}`
      );
      return resObj.data;
    } catch (error) {
      return error;
    }
  },

  async skipItemValidation(_, payload) {
    try {
      const resObj = await axios.post(
        `${constants.gatewayServiceUrl}/alex/library/assignment/skip-validation`,
        payload
      );
      return resObj.data;
    } catch (error) {
      return error;
    }
  },
  async unassignCourse(_, payload) {
    try {
      const resObj = await axios.post(
        `${constants.gatewayServiceUrl}/alex/library/assignment/remove`,
        payload
      );
      return resObj.data;
    } catch (error) {
      return error;
    }
  },
};